<template>
  <div class="warp">
    <BaseHeader />
    <main> 
      <PaymentSuccessLeft page="BillRecieve" />
      <div id="payment" v-if="billComplete">  
        <button :class="{deactive :!hasPDF, 'btn titillium-sm':true}" :disabled="!hasPDF"  @click="downloadDeposit()" style="padding-right: 46px;"> {{ text.downloadButtonText }} </button>
      </div>
      <div id="payment" v-if="!billComplete"> 
            <v-layout align-center justify-center row fill-height> 
              <div class="red--text text-xs-center" v-html="text.warn" />
            </v-layout>
      </div>
 

    </main>

    <main> 
      <div id="recieve" v-if="billComplete"> 
          <div v-if="hasPDF">
            <!-- <h3>{{ text.receipt }}</h3> -->
            <div v-for="i in numPages" :key="i" class="pb-5">
              <pdf :src="src" :page="i" style="display: block; width: 100%" />
              <div class="text-xs-center">Page : {{ i }} / {{ numPages }}</div>
            </div>
          </div>
          <div v-else class="title text-xs-center pt-3 pb-1">
            <v-progress-circular
              v-if="!isTry"
              indeterminate
              color="primary"
            ></v-progress-circular>
            <div v-else>
              {{ text.na }}
            </div>
          </div>
      </div> 
    </main>

  </div>
   
</template>

<script>
import * as moment from 'moment'
import pdf from 'vue-pdf' 
export default {
  components: {
    pdf
  },
  data() {
    return {
      billDataStatus: 0,
      src: '',
      numPages: undefined,
      currentPage: 0,
      pageCount: 0,
      isTry: false,
      code: '',
      completed: false,
      bycode: true,
      now: moment()
        .add(543, 'y')
        .locale('th')
        .format('DD MMM YYYY, HH.mm')
    }
  },
  mounted() {
        if (sessionStorage.getItem('linkcode') || localStorage.linkcode == this.$route.query.linkcode) {
          this.$store.dispatch('getBillDataValidated', this.$route.query.linkcode)
          let checkEbillDone = setInterval(() => {
            if (this.$route.name == 'billRecieve') {
              this.$store
                .dispatch('getBillDataStatus', this.$route.query.linkcode)
                .then(() => {
                  if (this.$store.state.billDataStatus < 4) {
                    clearInterval(checkEbillDone)
                    this.$router.push(
                      '/paymentMethods/?linkcode=' + this.$route.query.linkcode
                    )
                  } else {
                    this.$store.dispatch('getBillDataValidated', this.$route.query.linkcode)
                    if (this.billComplete) {
                      this.$store
                      .dispatch('recieveDepositBillUrl', {
                        linkcode: this.$route.query.linkcode
                      })
                      .then(() => {
                        if (this.$store.state.billUrl != '') {
                          clearInterval(checkEbillDone)
                          this.src = pdf.createLoadingTask(this.$store.state.billUrl)
                          // this.src.then(pdf => {
                          this.src.promise.then(pdf => {
                            this.numPages = pdf.numPages;
                          });
                          // this.downloadDeposit()
                          this.isTry = true
                        } else {
                          this.isTry = true
                        }
                      })
                    }
                  }
                })
            }
          }, 3000); 
      } else {
        this.$router.push(`/authen/?linkcode=${this.$route.query.linkcode}`)
      }
  },
  created() {
  },
  methods: {  
  },
  computed: {
    hasPDF() {
      if (this.src == '') {
        return false
      }
      return true
    },

    billComplete() {
      return (
        this.$store.state.billDataStatus == 5 ||
        this.$store.state.billDataStatus == '5'
      )
    },

    text() {
      let obj = {}
      if (this.$store.state.language == 'TH') {
        obj = {
          downloadButtonText: 'ดาวน์โหลดใบเสร็จ',
          na: 'ไม่มีเอกสารใบรับฝากเงิน',
          warn: '',//เกิดข้อผิดพลาดจากระบบ
          receipt: 'ใบเสร็จ'
        }

        if (
          this.$store.state.billDataStatus == 4 ||
          this.$store.state.billDataStatus == '4'
        ) {
          obj.warn = 'ชำระเงินเรียบร้อย'
        }

        if (
          this.$store.state.billDataStatus == 7 ||
          this.$store.state.billDataStatus == '7'
        ) {
          obj.warn = 'จองวงเงินเรียบร้อย'
        }

        if (
          this.$store.state.billDataStatus == 8 ||
          this.$store.state.billDataStatus == '8'
        ) {
          obj.warn = 'จองวงเงินเรียบร้อย'
        }
      } else {
        obj = {
          downloadButtonText: 'Download Receipt',
          na: 'Not Available',
          warn: '',//Oops, some error from system.
          receipt: 'Receipt',
        }

        if (
          this.$store.state.billDataStatus == 4 ||
          this.$store.state.billDataStatus == '4'
        ) {
          obj.warn = 'Payment Success '
        }

        if (
          this.$store.state.billDataStatus == 7 ||
          this.$store.state.billDataStatus == '7'
        ) {
          obj.warn = 'Reserve Credit Successful'
        }

        if (
          this.$store.state.billDataStatus == 8 ||
          this.$store.state.billDataStatus == '8'
        ) {
          obj.warn = 'Reserve Credit Successful'
        }
      }
      return obj
    }
  },
  methods: {
    recieved() {
      this.completed = !this.completed
      this.now = moment()
        .add(543, 'y')
        .locale('th')
        .format('DD MMM YYYY, HH.mm')
    },
    inputCode(evt) {
      evt = evt ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (this.isNumber(charCode)) {
        if (evt.target.nextElementSibling) evt.target.nextElementSibling.focus()
      } else if (this.isDelete(charCode)) {
        if (evt.target.previousElementSibling)
          evt.target.previousElementSibling.focus()
      } else {
        evt.target.value = ''
      }
    },
    isNumber(charCode) {
      if (
        (charCode < 96 || charCode > 105) &&
        (charCode < 48 || charCode > 57)
      ) {
        return false
      } else {
        return true
      }
    },
    isDelete(charCode) {
      if (charCode == 8) {
        return true
      } else {
        return false
      }
    },
    downloadDeposit() {
      const link = document.createElement('a')
      link.href = this.$store.state.billUrl
      link.setAttribute('download', this.$store.state.billUrl + '.pdf') //or any other extension
      document.body.appendChild(link)
      link.click()
    }
  }
}
</script>
 
<style>
#recieve{
  width:97%;  
  text-align: center;
  margin: auto;
} 
</style>